<template>
  <ckeditor :editor="editor"
            v-model="content"
            :config="editorConfig"
            @input="onContentChange">
  </ckeditor>
</template>

<script>
import { clone } from 'lodash'
import CKEditor from '@ckeditor/ckeditor5-vue'

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline'
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment'
import TablePlugin from '@ckeditor/ckeditor5-table/src/table'
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import FontPlugin from '@ckeditor/ckeditor5-font/src/font'
import FontSizePlugin from '@ckeditor/ckeditor5-font/src/fontsize'
import FontFamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily'
import FontColorPlugin from '@ckeditor/ckeditor5-font/src/fontcolor'
import FontBackgroundPlugin from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor'
import ListPlugin from '@ckeditor/ckeditor5-list/src/list'

import Vue from 'vue'
Vue.use(CKEditor)

export default {
  name: 'EditorComponent',
  model: {
    prop: 'editorContent',
    event: 'onEditorContentChange'
  },
  props: {
    editorContent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      content: '',
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin, ParagraphPlugin,
          BoldPlugin, ItalicPlugin, UnderlinePlugin, StrikethroughPlugin,
          AlignmentPlugin,
          FontPlugin, FontSizePlugin, FontFamilyPlugin, FontColorPlugin, FontBackgroundPlugin,
          ListPlugin,
          TablePlugin, TableToolbarPlugin
        ],
        toolbar: {
          items: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify', '|',
            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
            'numberedList', 'bulletedList', '|',
            'insertTable'
          ]
        },
        table: {
          contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        }
      }
    }
  },
  watch: {
    editorContent: function (newVal) {
      this.content = newVal
    }
  },
  created: async function () {
    this.content = clone(this.editorContent)
    this.isLoading = false
  },
  methods: {
    onContentChange: function () {
      this.$emit('onEditorContentChange', this.content)
    }
  }
}
</script>
